import { useMutation } from "@tanstack/react-query";
import { createGuardian as apiCreate } from "../../api/apiGuardians";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";
export function useCreateGuardian() {
    const navigate = useNavigate(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: createGuardian, isPending, error } = useMutation({ mutationFn: (req) => apiCreate(req),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); navigate('/guardians'); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); } });
    return { isPending, error, createGuardian };
}
